import {setCookie} from "@js/globalFunctions/cookieHandling";
import {determineCurrentBaseUrl} from "@js/globalFunctions/determineCurrentBaseUrl";

export function rewriteUrlPaging(pagination, rewriteUrl){
	rewriteUrl = ( typeof rewriteUrl !== 'undefined' ) ? rewriteUrl : true ;
	if( siteTmpl !== 'tmpl-map' && !isNaN(pagination) )
	{
		pagination = Number(pagination);
		const curUrl = window.location.href;
		
		if( dataholder.maxPaging === false && $('#pagination-controller').length !== 0 )
		{
			dataholder.maxPaging = Number($('#pagination-controller').attr('data-maxpages'));
			setCookie('tempMaxPageCount', dataholder.maxPaging, 1);
		}
		
		const isWithSlash = ( curUrl.indexOf('/page=/') !== -1 ) ? curUrl.indexOf('/#/page') : 0;
		const slashBeforeHash = (isWithSlash !== -1 ) ? '/' : '' ;
		const newUrl = curUrl.split("/");
		const feriehus = dataholder.feriehusNavn;
		const paginationPlusOne = Number(pagination)+1;
		const paginationPlusOnePrev = Number(pagination)-1;
		let returnUrl, returnUrlPrev, returnUrlNext;
		if( curUrl.indexOf('/page=/') !== -1 )
		{
			if( curUrl.indexOf('/page=/'+paginationPlusOnePrev) !== -1 )
			{
				returnUrl = curUrl.replace('/page=/'+paginationPlusOnePrev, '/page=/'+pagination);
				returnUrlPrev = curUrl;
				returnUrlNext = curUrl.replace('/page=/'+paginationPlusOnePrev, '/page=/'+paginationPlusOne);
			}
			else
			{
				returnUrl = curUrl.replace('/page=/'+dataholder.lastPagin, '/page=/'+pagination);
				returnUrlPrev = curUrl.replace('/page=/'+dataholder.lastPagin, '/page=/'+paginationPlusOnePrev);
				returnUrlNext = curUrl.replace('/page=/'+dataholder.lastPagin, '/page=/'+paginationPlusOne);
			}
		}
		else if(curUrl.indexOf('#'+feriehus) !== -1 )
		{
			
			returnUrl = curUrl.replace('#'+feriehus, '#/page=/'+pagination);
			returnUrlPrev = curUrl.replace('#'+feriehus, '#/page=/'+paginationPlusOnePrev);
			returnUrlNext = curUrl.replace('#'+feriehus, '#/page=/'+paginationPlusOne);
			
		}
		else
		{
			if(newUrl.length === 5 && siteTmpl !== "tmpl-soeg"){
				returnUrl = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+pagination;
				returnUrlPrev = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+(Number(pagination)-1);
				returnUrlNext = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+(Number(pagination)+1);
			}else{
				if(newUrl[4] === "#"){
					returnUrl = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+pagination;
					returnUrlPrev = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+(Number(pagination)-1);
					returnUrlNext = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+(Number(pagination)+1);
				}else if (newUrl.length === 7){
					returnUrl = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+pagination;
					returnUrlPrev = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+(Number(pagination)-1);
					returnUrlNext = siteUrl+"/"+newUrl[3]+slashBeforeHash+"#/page=/"+(Number(pagination)+1);
				}else{
					returnUrl = siteUrl+"/"+newUrl[3]+"/"+newUrl[4]+slashBeforeHash+"#/page=/"+pagination;
					returnUrlPrev = siteUrl+"/"+newUrl[3]+"/"+newUrl[4]+slashBeforeHash+"#/page=/"+(Number(pagination)-1);
					returnUrlNext = siteUrl+"/"+newUrl[3]+"/"+newUrl[4]+slashBeforeHash+"#/page=/"+(Number(pagination)+1);
				}
			}
		}
		dataholder.lastPagin = pagination;
		if( rewriteUrl )
		{
			document.location = returnUrl;
		}
		if($('#pagination-controller').length > 0)
		{
			if($("#pagination-controller").hasClass('version-2'))
			{
				const baseUrl = determineCurrentBaseUrl();
				updatePaginationHtml(baseUrl,pagination,dataholder.maxPaging);
			}
			else
			{
				let nextEl = $("#pagination-controller a[rel='next']");
				let prevEl = $("#pagination-controller a[rel='prev']");
				if( paginationPlusOne <= dataholder.maxPaging && nextEl.length === 0 )
				{
					var nextString = '<a rel="next" href="#">0</a>';
					$("#pagination-controller").append(nextString);
					nextEl = $("#pagination-controller a[rel='next']");
				}
				
				if( prevEl.length === 0 && paginationPlusOnePrev > 0 )
				{
					var prevString = '<a rel="prev" href="#">0</a>';
					$("#pagination-controller").prepend(prevString);
					prevEl = $("#pagination-controller a[rel='prev']");
				}
				
				if( paginationPlusOnePrev === 0 )
				{
					prevEl.remove();
				}
				
				if( paginationPlusOne > dataholder.maxPaging && $("#pagination-controller.static a[rel='next']").length === 0 )
				{
					nextEl.remove();
					returnUrlNext = '';
				}
				if( paginationPlusOnePrev < 1 && $("#pagination-controller.static a[rel='prev']").length === 0 )
				{
					prevEl.remove();
					returnUrlPrev = '';
				}
				
				let paginationNextUrl = returnUrlNext.replace('#/', '').replace('=/','/');
				let paginationPrevUrl = returnUrlPrev.replace('#/', '').replace('=/','/');
				
				if( paginationNextUrl.substr(0, -1) !== '/')
				{
					paginationNextUrl += '/';
				}
				
				if( pagination === 2 )
				{
					paginationPrevUrl = paginationPrevUrl.split('/page')[0];
				}
				
				if( paginationPrevUrl.substr(0, -1) !== '/')
				{
					paginationPrevUrl += '/';
				}
				
				nextEl.attr("href", paginationNextUrl).html(paginationPlusOne);
				$(document).find("head link[rel='next']").attr("href", paginationNextUrl);
				prevEl.attr("href", paginationPrevUrl).html(paginationPlusOnePrev);
				$(document).find("head link[rel='prev']").attr("href", paginationPrevUrl);
			}
		}
		
		if( plug === 'soeg' || plug === 'suche' )
		{
			const holder = $('#paginationHolder');
			if( !holder.hasClass('hidden') )
			{
				holder.addClass('hidden');
			}
		}
	}
}

function updatePaginationHtml(permalink,currentPage,maxPages)
{
	const previous = currentPage - 1;
	const next =  currentPage + 1;
	
	let urls = {'prev': '', 'next': '', 'standard': []};
	
	if(previous > 1){
		urls['prev'] = '<a rel="prev" href="'+permalink+'page/'+previous+'/">'+wpTranslatedStrings.terms.previousPage+'</a>';
	}else if(previous === 1){
		urls['prev'] = '<a rel="prev" href="'+permalink+'">'+wpTranslatedStrings.terms.previousPage+'</a>';
	}
	if(next <= maxPages){
		urls['next'] = '<a rel="next" href="'+permalink+'page/'+next+'/">'+wpTranslatedStrings.terms.nextPage+'</a>';
	}
	
	let limit = currentPage + 5;
	let hasLast = false;
	
	if(currentPage - 5 > 1)
	{
		urls['standard'].push('<a href="'+permalink+'page/1/" >1</a>');
		if(currentPage - 5 > 2)
			urls['standard'].push('<span>...</span>');
	}
	
	for(let i = currentPage - 5; i <= limit; i++)
	{
		if(i < 1)
		{
			limit++;
		}
		else
		{
			if(i > maxPages)
			{
				hasLast = true;
				break;
			}
			
			let rel = '';
			if(i === currentPage)
			{
				urls['standard'].push('<span>'+i+'</span>');
			}
			else if(i === currentPage-1)
			{
				rel = 'rel="prev"';
			}
			else if(i === currentPage+1)
			{
				rel = 'rel="next"';
			}
			
			if(i === maxPages)
				hasLast = true;
			
			if(i !== currentPage)
				urls['standard'].push('<a '+rel+' href="'+permalink+'page/'+i+'/" >'+i+'</a>');
			
			if(i === limit && i !== maxPages)
				urls['standard'].push('<span>...</span>');
		}
	}
	
	if(!hasLast)
		urls['standard'].push('<a href="'+permalink+'page/'+maxPages+'/">'+maxPages+'</a>');
	
	let string = '';
	
	if(urls['prev'] !== '')
		string += urls['prev'];
	
	for(let i = 0; i < urls['standard'].length; i++)
		string += urls['standard'][i];
	
	if(urls['next'] !== '')
		string += urls['next'];
	
	$("#pagination-controller").html(string);
}

export function rewriteBlogUrlPaging(pagination){
	const curUrl = window.location.href;
	const newUrl = curUrl.split("/");
	let returnUrl;
	if(newUrl.length === 5){
		returnUrl = siteUrl+"/"+newUrl[3]+"/#/page=/"+pagination;
	}else{
		if(newUrl[4] === "#"){
			returnUrl = siteUrl+"/"+newUrl[3]+"/#/page=/"+pagination;
		}else{
			returnUrl = siteUrl+"/"+newUrl[3]+"/"+newUrl[4]+"/#/page=/"+pagination;
		}
	}
	document.location = returnUrl;
	const paginationPlusOne = Number(pagination)+1;
	$(document).find("#pagination-controller a[rel='next']").attr("href", "#/page=/"+paginationPlusOne).html(paginationPlusOne);
	$(document).find("head link[rel='next']").attr("href", "/page=/"+paginationPlusOne);
}
